import React, { useEffect, useState } from "react";
import { bankInfoType } from "../../../../common/interfaces/myProfile/personalDetails/bankInfoType";
import DTOBankInfo from "./DTOBankInfo";
import BankInfoPresenter from "./BankInfoPresenter";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";
function BankInfoController() {
  const { t } = useTranslation();
  const [bankInfo, setBankInfo] = useState<any>([]);
  const [fields_of_banks, setfields_of_banks] = useState<any>([]);
  const [fields_of_exchange, setfields_of_exchange] = useState<any>([]);

  function callBackFunc(data: any) {
    setBankInfo(data);
  }
  function getBankFields(data: any) {
    setfields_of_banks(data);
  }
  function getExchangeFields(data: any) {
    setfields_of_exchange(data);
  }

  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <div>
      <DTOBankInfo
        setBankInfo={callBackFunc}
        setBank_Fields={getBankFields}
        setExchange_Fields={getExchangeFields}
      />
      <BankInfoPresenter
        bankInfoData={bankInfo}
        hr_view={hr_view}
        trans={t}
        fields_of_banks={fields_of_banks}
        fields_of_exchange={fields_of_exchange}
      />
    </div>
  );
}

export default BankInfoController;
